varying vec2 vUv;
uniform float time;
uniform float uNoise;
uniform vec2 resolution;
uniform float ratio;
uniform sampler2D uNoiseTexture;
uniform float uNoiseSize;
#define PI 3.14159265359
#define MOD3 vec3(443.8975,397.2973, 491.1871)
vec3 hash32(vec2 p)
{
	vec3 p3 = fract(vec3(p.xyx) * MOD3);
    p3 += dot(p3, p3.yxz+19.19);
    return fract(vec3((p3.x + p3.y)*p3.z, (p3.x+p3.z)*p3.y, (p3.y+p3.z)*p3.x));
}

float PHI = 1.61803398874989484820459;  // Φ = Golden Ratio   

float gold_noise(in vec2 xy, in float seed){
       return fract(tan(distance(xy*PHI, xy)*seed)*xy.x);
}

 float rand(vec2 co)
{
    float a = 12.9898;
    float b = 78.233;
    float c = 43758.5453;
    float dt= dot(co.xy ,vec2(a,b));
    float sn= mod(dt,3.14);
    return fract(sin(sn) * c);
}

void main() {
    float loctime = floor(time*40.);
    // vec3 rnd = hash32( floor(1000.*vUv) +vec2(loctime) );
    // gl_FragColor = vec4(hash32(rnd.xy),0.01); 
    // gl_FragColor = vec4(vec3(rand(floor(gl_FragCoord.xy*0.5*uNoiseSize) + loctime)),uNoise); 

    vec2 noiseUV = (gl_FragCoord.xy/resolution)/ratio;
    float aspect = resolution.x/resolution.y;
    noiseUV.x *= aspect;
    noiseUV *=uNoiseSize *resolution.x/512./ratio;
    
    noiseUV += 0.15*vec2(loctime);
    noiseUV = fract(noiseUV);
    gl_FragColor = texture2D(uNoiseTexture, noiseUV);
    gl_FragColor.a = uNoise;
    // gl_FragColor = vec4(noiseUV,0.,1.);
}